import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=4f70cc22&"
import script from "./UserPermissions.vue?vue&type=script&lang=ts&"
export * from "./UserPermissions.vue?vue&type=script&lang=ts&"
import style0 from "./UserPermissions.vue?vue&type=style&index=0&id=4f70cc22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports